import { createRouter, createWebHistory } from "vue-router";

import NotFound from "../views/404.vue";
import Home from "../views/Landing.vue";
import About from "../views/About.vue";
import Services from "../views/Services.vue";
import Divisions from "../views/Divisions.vue";
import Work from "../views/Work.vue";
import QualitySafety from "../views/QualitySafety.vue";
import TestimonialPage from "../views/Testimonial.vue";
import ContactPage from "../views/Contact.vue";

import { stopAllPolling } from "../pollingManger.js";
import { applySeo } from "../config/seo.js";

// Titles and descriptions are not declared here — they live in `seo.config.js`
// at the project root, keyed by path, so the sitemap generator reads the same
// table. `applySeo` writes them into the document head after each navigation.
const routes = [
  { path: "/", component: Home },
  { path: "/about", component: About },
  { path: "/services", component: Services },
  { path: "/divisions", component: Divisions },
  { path: "/our-work", component: Work },
  { path: "/quality-safety", component: QualitySafety },
  { path: "/testimonial", component: TestimonialPage },
  { path: "/contact", component: ContactPage },
  { path: "/:pathMatch(.*)*", component: NotFound },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      // offset for the fixed header
      return { el: to.hash, top: 90, behavior: "smooth" };
    }

    return { top: 0, left: 0 };
  },
});

router.beforeEach((to, from, next) => {
  stopAllPolling();
  next();
});

router.afterEach((to) => {
  applySeo(to);
});

export default router;
